import { MapTo } from '@adobe/aem-react-editable-components';
import PullQuote, { PullQuoteEditConfig } from './PullQuote';

export default MapTo('cob-corp-acquisition/components/creditonebank/pull-quote')(PullQuote, PullQuoteEditConfig);